export const FEATURE_STATE = {
  TOTAL: "TOTAL",
  PENDING: "PENDING",
  CONFIRMED: "CONFIRMED",
  HOLD: "HOLD",
  HIDDEN: "HIDDEN",
  NOT_DETECTED: "NOT_DETECTED",
} as const;

export const FEATURE_STATE_CONVERT = {
  TOTAL: "TOTAL",
  PENDING: "",
  CONFIRMED: "CORRECT",
  HOLD: "UNCERTAIN",
  HIDDEN: "INCORRECT",
  NOT_DETECTED: "NOT_DETECTED",
} as const;

export type FeatureState = (typeof FEATURE_STATE)[keyof typeof FEATURE_STATE];

export type FeatureStateConvert =
  (typeof FEATURE_STATE_CONVERT)[keyof typeof FEATURE_STATE_CONVERT];
